import { render, staticRenderFns } from "./Dashboard.template.vue?vue&type=template&id=228ab1f0&scoped=true&"
var script = {}
import style0 from "./Dashboard.template.vue?vue&type=style&index=0&id=228ab1f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ab1f0",
  null
  
)

export default component.exports